module.exports = __webpack_public_path__ + "media/hyper/images/logo_sm_dark-3e50617ba85fb82dd3d43ba581919bcc.png";